import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { parseQueryString } from "_helpers";
function PublicRoute({ children }) {
  const { search, pathname } = useLocation();
  const { token } = parseQueryString(search);

  if (pathname.endsWith("/login") && token) {
    localStorage.removeItem("trademark-membership-user");
    localStorage.removeItem("userInfo");
  }

  const trademarkToken = localStorage.getItem("trademark-membership-user");
  const userTrademarkToken = localStorage.getItem("userInfo");

  return trademarkToken && userTrademarkToken ? <Navigate to={{ pathname: "/" }} /> : children;
}

PublicRoute.propTypes = {
  children: PropTypes.element,
};

export default PublicRoute;
